import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import Axios from '../../utils/Axios';
import API from '../../common/SummaryAPI';
import AxiosToastError from '../../utils/AxiosToastError';

const Verify = () => {
  const [OTP, setOTP] = useState(new Array(6).fill(""));
  const Boxes = useRef([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  const userEmail = state?.email;
  useEffect(() => {
    if (!userEmail) {
      navigate('/forgot-password');
    }
  }, [userEmail, navigate]);

  const updateOTP = (event, index) => {
    const val = event.target.value.replace(/\D/g, ""); 
    if (val.length > 1) return;

    const OTPcopy = [...OTP];
    OTPcopy[index] = val;
    setOTP(OTPcopy);

    if (val && index < 5) Boxes.current[index + 1]?.focus();
    if (!val && index > 0) Boxes.current[index - 1]?.focus();
  };

  const allDigitsFilled = OTP.every(val => val);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await Axios({
        ...API.forgot_password_otp_verification,
        data: {
          otp: OTP.join(""),
          email: userEmail
        }
      });

      const res = response.data;
      if (res.error) return toast.error(res.message);
      if (res.success) {
        toast.success(res.message);
        setOTP(Array(6).fill(""));
        navigate("/reset-password", {
          state: { email: userEmail, data: res }
        });
      }
    } catch (err) {
      AxiosToastError(err);
    }
  };

  return (
    <div>
      <h2>Enter OTP</h2>
      <p>Check your email for the 6-digit code</p>

      <form onSubmit={handleSubmit}>
        <div>
          {OTP.map((val, idx) => (
            <input
              key={idx}
              type="text"
              maxLength={1}
              value={val}
              ref={el => Boxes.current[idx] = el}
              onChange={(e) => updateOTP(e, idx)}
              onFocus={(e) => e.target.select()}
            />
          ))}
        </div>
        <button type="submit" disabled={!allDigitsFilled}>
          Verify
        </button>
      </form>
      <p>
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
};

export default Verify;
